import React from 'react';
import { AlertOctagon, ShoppingBag, FileText, ArrowRight } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Infringements feature
 * Displays information about the Infringements feature and its benefits
 */
export const InfringementsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Brand Infringements"
      description="Monitor and take action against unauthorized use of your brand assets, trademarks, and intellectual property across the web."
      icon={<AlertOctagon className="h-8 w-8 text-blue-600" />}
      featureName="infringements"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ShoppingBag className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Marketplace Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Detect counterfeit products and unauthorized sellers across major online marketplaces and e-commerce platforms.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileText className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Trademark Protection</h3>
          </div>
          <p className="text-gray-400">
            Monitor for unauthorized use of your trademarks in domains, content, and digital advertising.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertOctagon className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Violation Tracking</h3>
          </div>
          <p className="text-gray-400">
            Track and manage brand violations with detailed case management and enforcement workflows.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ArrowRight className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Enforcement Actions</h3>
          </div>
          <p className="text-gray-400">
            Take action against infringements with automated takedown requests, cease and desist notices, and legal actions.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
